import { CALENDAR_KEYS, EVENT_STATUSES } from '@/types/admin/events';
import { SEMANTIC_COLORS } from '@/constants/residents/residentColors';
import type { GlassStatusVariant } from '@/components/admin/redesign';

export const getEventStatusColor = (status: string): string => {
  const key = CALENDAR_KEYS.find((k) => k.title === status);
  return key?.color || SEMANTIC_COLORS.text.tertiary;
};

export const getEventStatusVariant = (status: string): GlassStatusVariant => {
  switch (status) {
    case EVENT_STATUSES.PUBLISHED:
      return 'success';
    case EVENT_STATUSES.SCHEDULED:
      return 'info';
    case EVENT_STATUSES.DRAFT:
      return 'warning';
    case EVENT_STATUSES.PAST:
      return 'neutral';
    default:
      return 'info';
  }
};
